var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "show-tag"
  }, [_c("div", {
    staticClass: "show-container",
    on: {
      click: _vm.onClick
    }
  }, [_vm._t("icon")], 2), _vm.isShow && _vm.data.length ? _c("div", {
    staticClass: "modal"
  }, [_vm._l(_vm.data, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "modal-content"
    }, [_vm._v(" " + _vm._s(item.fieldKey) + "：" + _vm._s(item.fieldFrontValue || item.fieldValue) + " ")]);
  }), _vm.$slots.footer ? _c("div", {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2) : _vm._e()], 2) : _vm.isShow ? _c("div", {
    staticClass: "modal"
  }, [_c("div", {
    staticClass: "modal-content"
  }, [_vm._v(" " + _vm._s(_vm.$t("暂无数据")) + "    "), _vm._t("footer")], 2)]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };